<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.25 4.16479V16.2918L5.55375 10.5955L4.5 11.6648L12 19.1648L19.5 11.6648L18.4462 10.5955L12.75 16.2918V4.16479H11.25Z" fill="currentColor"/>
</svg>
